export default "__VITE_ASSET__5324d220__"